<template>
    <v-container class="ma-0 pa-0">

      <!-- Person data -->
      <v-expand-transition>
        <MessageBox class="my-5" type="info" v-if="dataForPerson && dataForPerson.length>0">
          <h6>{{ $t('byn2import.notice.title') }}</h6>
          <p>{{ $t('byn2import.notice.text') }}</p>

          <p>
            <i18n path="byn2import.notice.contactText" tag="p">
              <a :href="links.main.bynContactRegions" target="_blank">{{ $t('byn2import.notice.contactLink') }}</a>
            </i18n>

            <i18n path="byn2import.notice.read2020" tag="p">
              <a :href="links.main.bynContract2020" target="_blank">{{ $t('byn2import.notice.read2020Link') }}</a>
            </i18n>
          </p>

          <v-container v-for="(item, index) in dataForPerson" :key="'edu_' + index">
          <p class="mb-0 pb-0">
              <strong>{{ get(dataForPerson[index], 'byn2Data.companyName', '') }}</strong> ({{ get(dataForPerson[index], 'byn2Data.companyOrg', '') }})<br/>
              {{ get(dataForPerson[index], 'byn2Data.professionName', '') }}, {{ $t('byn2import.notice.qtime', {qTimeLeft: get(dataForPerson[index], 'byn2Data.qTimeLeft', 36)}) }} {{ $t('byn2import.notice.timeleft', {timeLeft: get(dataForPerson[index], 'byn2Data.timeLeft', 3600)}) }}
          </p>
          <p class="mt-0 pt-0">
              <div class="d-flex">
                  <v-radio-group v-model="chkPersonImport[index]" row class="mt-n4 pt-0">
                    <v-radio
                        :label="$t('byn2import.notice.radio-ok')"
                        value="OK"
                        class="mb-n4"
                    ></v-radio>
                    <br/><br/>
                    <v-radio
                        :label="$t('byn2import.notice.radio-nok1')"
                        value="NOK1"

                    ></v-radio>
                    <br/><br/>
                    <v-radio
                        :label="$t('byn2import.notice.radio-nok2')"
                        value="NOK2"
                    ></v-radio>
                  </v-radio-group>
                  <v-btn large outlined @click="saveApprenticeAnswer(index)" min-height="35">
                      <v-icon class="ml-n1 mr-1">$sl-save</v-icon>
                      {{ $t('labels.save')}}
                  </v-btn>
              </div>
          </p>
        </v-container>
        </MessageBox>
    </v-expand-transition>

    <!-- Company data -->
    <v-expand-transition>
      <MessageBox class="my-5" type="info" v-if="dataForCompany && dataForCompany.length>0">
        <h6>{{ $t('byn2import.notice.title') }}</h6>
        <p>{{ $t('byn2import.notice.company-text') }}</p>
        <p>
          <i18n path="byn2import.notice.read2020" tag="p">
            <a :href="links.main.bynContract2020" target="_blank">{{ $t('byn2import.notice.read2020Link') }}</a>
          </i18n>
        </p>
        <v-container v-for="(item, index) in dataForCompany" :key="'cedu_' + index">
          <p class="mb-0 pb-0">
            <div class="mb-1">
              <strong>{{ get(dataForCompany[index], 'byn2Data.companyName', '') }}</strong>
            </div>
            <strong>{{ get(dataForCompany[index], 'byn2Data.personName', '') }}</strong> ({{ get(dataForCompany[index], 'byn2Data.personalNumber', '') }})<br/>
            {{ get(dataForCompany[index], 'byn2Data.professionName', '') }}, {{ $t('byn2import.notice.qtime', {qTimeLeft: get(dataForCompany[index], 'byn2Data.qTimeLeft', 36)}) }} {{ $t('byn2import.notice.timeleft', {timeLeft: get(dataForCompany[index], 'byn2Data.timeLeft', 3600)}) }}
          </p>
          <p class="mt-0 pt-0">
              <div class="d-flex">
                  <v-radio-group v-model="chkCompanyImport[index]" row class="mt-n4 pt-0">
                    <v-radio
                        :label="$t('byn2import.notice.radio-company-ok')"
                        value="OK"
                        class="mb-n4"
                    ></v-radio>
                    <br/><br/>
                    <v-container v-if="chkCompanyImport[index] == 'OK'">

                      <template v-if="get(dataForCompany[index], 'company.hasDepartments', false)">
                        <v-select
                          :items="get(dataForCompany[index], 'company.departments', [])"
                          v-model="chkCompanyDepartment[index]"
                          :rules="[rules.required]"
                          append-icon="$sl-arrow-down"
                          item-text="name"
                          item-value="id"
                          :label="$t('company.section')"
                          outlined
                        />
                      </template>

                      <v-select
                        :items="filteredWorkplaces(index)"
                        v-model="chkCompanyWorkplace[index]"
                        :rules="[rules.required]"
                        :disabled="(get(dataForCompany[index], 'company.hasDepartments', false) && !chkCompanyDepartment[index] > 0) ? true : false"
                        item-text="name"
                        append-icon="$sl-arrow-down"
                        item-value="id"
                        :label="$t('labels.workplace')"
                        outlined
                      />

                      <v-select
                        :items="filteredInstructors(index)"
                        v-model="chkCompanyInstructor[index]"
                        :rules="[rules.required]"
                        item-disabled="disableItem"
                        item-text="fullName"
                        item-value="id"
                        :label="$t('fields.instructor')"
                        hint="Visar handledare som idag kan handleda ytterligare en lärling under kvalificeringstid"
                        :persistent-hint="true"
                        outlined        
                      ></v-select>


                    </v-container>
                    <v-radio
                        :label="$t('byn2import.notice.radio-company-nok')"
                        value="NOK"
                    ></v-radio>
                  </v-radio-group>
                  <v-btn large outlined @click="saveCompanyAnswer(index)" min-height="35">
                      <v-icon class="ml-n1 mr-1">$sl-save</v-icon>
                      {{ $t('labels.save')}}
                  </v-btn>
              </div>
          </p>
        </v-container>

      </MessageBox> 
    </v-expand-transition>
  
  </v-container>
</template>


<script>
import API from '@/services/api.js'
import filter from 'lodash/filter'
import {mapActions, mapGetters} from 'vuex'
import MessageBox from '@/components/Common/MessageBox.vue'
import { forEach, get, pick } from 'lodash'
import {RulesMixin, InstructorAbilities, CompanyRoles} from '@/components/mixins'

export default {
  name: 'Byn2Import',

  mixins: [RulesMixin, InstructorAbilities, CompanyRoles],

  components: {
    MessageBox
  },
  data: () => ({
    links: require('../../lib/external-links.json'),
    dataForPerson: null,
    dataForCompany: null,
    
    chkPersonImport: [],
    chkCompanyImport: [],

    chkCompanyDepartment: [],
    chkCompanyWorkplace: [],
    chkCompanyInstructor: [],
  }),

  created() {
    this.init()
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isApprentice', 'isCompanyUser', 'isImitatingUser', 'isAdministrator', 'isCompanyEducationResponsible']),
  },

  methods: {
    get: get,

    filteredWorkplaces(index) {
      let ret = []
      const wp = get(this.dataForCompany[index], 'company.workplaces', [])
      if (get(this.dataForCompany[index], 'company.hasDepartments', false)) {
        ret = wp.filter(cw => cw.departmentIds.find(d => d == this.chkCompanyDepartment[index]))
        //this.getInstructors()
      } else {
        ret = wp
      }
      return ret
    },

    filteredInstructors(index) {
      try {
        const instructors = get(this.dataForCompany[index], 'company.instructors', []).map(o => {
          let numGUAppr = 0
          if (o.apprentices) {
            numGUAppr = (o.apprentices.filter(a => { if(a.education) return a.education.basicEducationCertificate == null})).length
          }

          return {
            instructor: o,
            id: o.id,
            fullName: o.employed.firstName + ' ' + o.employed.lastName,
            email: o.employed.email,
            employed: o.employed,
            tradeCertificates: o.employed.tradeCertificates,
            numApprentices: o.apprentices ? o.apprentices.length : 0,
            numGUApprentices: numGUAppr,
            showMore: false,
            readInstructionsOn: o.employed.readInstructionsOn,
            canHaveAnotherApprentice: this.canHaveAnotherApprentice(o, 
              get(this.dataForCompany[index], 'byn2Data.professionId', 0), 
              get(this.dataForCompany[index], 'byn2Data.machineQualificationIds', []),
              false),
            disableItem: !Boolean(
              this.canHaveAnotherApprentice(o, 
                get(this.dataForCompany[index], 'byn2Data.professionId', 0), 
                get(this.dataForCompany[index], 'byn2Data.machineQualificationIds', []),
                false) && 
              o.employed.email && o.employed.email!='' &&
              this.haveCertificates(o, 
                get(this.dataForCompany[index], 'byn2Data.professionId', 0), 
                get(this.dataForCompany[index], 'byn2Data.machineQualificationIds', []),
                false)
            ),              
            instructorExemptions: o.employed.instructorExemptions || [],
            machineQualifications: o.employed.machinequalifications || [],
            instructorDepartmentIds: o.instructorDepartmentIds
          }
        })
        return instructors
      } catch(e) {
        console.log('Error filtering instructors:', e)
        return []
      }
    },

    async init() {
      // Get API to check if we are to be shown
      this.dataForPerson = await API.hasPersonalDataToApprove()
          .then(response => {
              return response.data
          })
      this.dataForCompany = await API.hasCompanyDataToApprove()
          .then(async (response) => {
            response.data = forEach(response.data, async (d) => {
              //- Grab departments
              try {
                if (d.company.hasDepartments) {
                  const deps = await API.listPublicDepartments(d.company.id)
                  if (this.isAdministrator) {
                    Object.assign(d.company, { departments: deps.data })
                  } else {
                    Object.assign(d.company, { departments: deps.data.filter((r) => this.getCurrentUserDepartmentsIds(d.company.id, this.isDepartmentAdministrator, false).find((u) => u == r.id)) })
                  }
                }
              } catch (e) {}

              //- Grab workplaces
              try {
                const emp = await API.getWorkplaces(d.company.id)
                Object.assign(d.company, { workplaces: emp.data })
              } catch (e) {}

              //- Grab employees
              try {
                const emp = await API.listEmployments(d.company.id, {type: 'instructor', scope: 'all'})
                Object.assign(d.company, { instructors: emp.data })
              } catch (e) {}

              return d
            })

            return response.data
          })
    },

    async saveApprenticeAnswer(index) {
        if (!this.chkPersonImport[index]) {
            this.$events.fire('showError', "Du måste ange om du vill flytta utbildningen eller inte.")
            return
        }

        //- SAVE
        try {
          const res = await API.updatePersonDataToApprove({
            ...this.dataForPerson[index],
            byn4data: {
              apprenticeAnswer: this.chkPersonImport[index]
            }
          })
          console.log(res)

          this.$events.fire('showInfo', this.$t('success.saved'))
          this.dataForPerson.splice(index,1)
          this.chkPersonImport.splice(index,1)
        } catch(e) {
          this.$events.fire('showError', this.$t('errors.save-failure'))
          console.log(e)
        }
    },

    async saveCompanyAnswer(index) {
        if (!this.chkCompanyImport[index]) {
            this.$events.fire('showError', "Du måste ange om du vill överföra utbildningen eller inte.")
            return
        }

        if (get(this.dataForCompany[index], 'company.hasDepartments', false)) {
          if (!(this.chkCompanyDepartment[index]) ) {
              this.$events.fire('showError', "Du måste ange avdelning.")
              return
          }
        }
        if (!(this.chkCompanyWorkplace[index]) ) {
            this.$events.fire('showError', "Du måste ange arbetsplats.")
            return
        }
        if (!(this.chkCompanyInstructor[index]) ) {
            this.$events.fire('showError', "Du måste ange handledare.")
            return
        }

        //- SAVE
        try {
          const res = await API.updateCompanyDataToApprove({
            ...this.dataForCompany[index],
            byn4data: {
              department: this.chkCompanyDepartment[index], 
              workplace: this.chkCompanyWorkplace[index], 
              instructor: this.chkCompanyInstructor[index],
              companyAnswer: this.chkCompanyImport[index]
            }
          })
          console.log(res)

          this.$events.fire('showInfo', this.$t('success.saved'))
          this.dataForCompany.splice(index,1)
          this.chkCompanyImport.splice(index,1)
        } catch(e) {
          this.$events.fire('showError', this.$t('errors.save-failure'))
          console.log(e)
        }
    },
  }
}
</script>

<style scoped></style>
